import React, { useState, useEffect } from "react";
import { adminApi } from "@/lib/api";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

export default function AuditPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState('');
  const [action, setAction] = useState('');
  const [selected, setSelected] = useState(null);

  const loadLogs = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await adminApi.get("/admin/audit-logs", { params: { search: search || undefined, action: action || undefined } });
      setLogs(Array.isArray(data?.items) ? data.items : []);
    } catch (e) {
      setError(e?.response?.data?.detail || "تعذر تحميل سجلات التدقيق");
      toast.error("تعذّر تحميل سجلات التدقيق");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLogs();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="space-y-6 fade-up">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="section-title text-2xl font-black">سجل التدقيق الأمني</h2>
          <p className="text-xs text-[var(--c-muted)] mt-1">تتبع كافة أنشطة المدراء وتغييرات النظام.</p>
        </div>
        <button onClick={loadLogs} className="btn-navy px-4 py-2 rounded-xl text-xs font-bold flex items-center gap-2">
          <RefreshCw className="w-3.5 h-3.5" />
          <span>تحديث</span>
        </button>
      </div>
      <div className="bg-white border border-[var(--c-border)] rounded-2xl p-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-[1fr_1fr_auto]"><input className="input-pro min-w-0" value={search} onChange={e=>setSearch(e.target.value)} placeholder="بحث بالإجراء أو المستخدم"/><input className="input-pro min-w-0" value={action} onChange={e=>setAction(e.target.value)} placeholder="اسم الإجراء (اختياري)"/><button className="btn-navy min-h-11 px-4 rounded-xl text-xs" onClick={loadLogs}>تطبيق الفلاتر</button></div>

      <div className="bg-white border border-[var(--c-border)] rounded-2xl shadow-sm overflow-hidden">
        {error ? (
          <div className="p-8 text-center space-y-3" role="alert"><p className="text-sm font-bold text-red-700">{error}</p><button onClick={loadLogs} className="btn-navy">إعادة المحاولة</button></div>
        ) : loading ? (
          <div className="p-8 text-center text-xs text-[var(--c-muted)]">جاري التحميل...</div>
        ) : logs.length === 0 ? (
          <div className="p-8 text-center text-xs text-[var(--c-muted)]">لا توجد سجلات تدقيق حالياً</div>
        ) : (
          <>
          <div className="hidden md:block mb-table-wrap">
            <table className="w-full text-end text-xs sm:text-sm">
              <thead className="bg-slate-50 border-b border-[var(--c-border)] text-[var(--c-muted)] font-bold">
                <tr>
                  <th className="p-4 text-start">التاريخ والوقت</th>
                  <th className="p-4">المدير المسؤول</th>
                  <th className="p-4">الإجراء / الحدث</th>
                  <th className="p-4">التفاصيل</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {logs.map((log) => (
                  <tr key={log.id} onClick={()=>setSelected(log)} className="hover:bg-slate-50/80 transition cursor-pointer">
                    <td className="p-4 text-start font-num text-xs text-[var(--c-muted)]">
                      {new Date(log.created_at).toLocaleString("ar-LB")}
                    </td>
                    <td className="p-4 font-bold text-[var(--c-navy)]">{log.admin_name || "المدير"}</td>
                    <td className="p-4 font-bold text-[var(--c-gold)]">{log.action}</td>
                    <td className="p-4 text-xs text-[var(--c-muted)] max-w-md break-words">{typeof log.details === "string" ? log.details : JSON.stringify(log.details || {})}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="md:hidden divide-y divide-[var(--c-border)]">{logs.map(log=><button key={log.id} onClick={()=>setSelected(log)} className="w-full p-4 text-start hover:bg-[var(--c-cream)]/60"><div className="flex items-start justify-between gap-3"><div className="min-w-0"><div className="font-bold break-words text-[var(--c-gold)]">{log.action}</div><div className="mt-1 text-xs text-[var(--c-navy)]">{log.admin_name || 'المدير'}</div></div><div className="shrink-0 text-[10px] text-[var(--c-muted)]">{new Date(log.created_at).toLocaleString('ar-LB')}</div></div><div className="mt-2 line-clamp-2 text-[10px] text-[var(--c-muted)]">{typeof log.details === 'string' ? log.details : JSON.stringify(log.details || {})}</div></button>)}</div>
          </>
        )}
      </div>
      {selected && <div className="fixed inset-0 z-50 bg-black/40 p-3 sm:p-4 flex items-center justify-center" onClick={()=>setSelected(null)}><div className="bg-white rounded-2xl p-5 w-full max-w-lg max-h-[calc(100dvh-1.5rem)] overflow-y-auto space-y-3" onClick={e=>e.stopPropagation()} role="dialog" aria-modal="true"><div className="flex justify-between"><h3 className="font-bold">تفاصيل سجل التدقيق</h3><button className="w-10 h-10" onClick={()=>setSelected(null)}>×</button></div><pre className="text-xs bg-slate-50 p-3 rounded-xl overflow-auto max-h-80" dir="ltr">{JSON.stringify(selected,null,2)}</pre></div></div>}
    </div>
  );
}
